<template>
    <div>
        <div class="bigdata_main">
            <div class="main_center">
                <div class="map">
                    <div id="container1" style="width: 100%; height: 100%;"></div>
                </div>
                <div class="content_left">
                    <div class="clearfix">
                        <el-row :row="24">
                            <el-col :span="6">
                                <el-select v-model="form.status" placeholder="全部" class="bg">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="在忙" value="1"></el-option>
                                    <el-option label="在闲" value="0"></el-option>

                                </el-select>
                            </el-col>
                            <el-col :span="8">
                                <div style="display:flex;width:90%;margin-left:10%">
                                    <el-input placeholder="请输入姓名" v-model="form.personName" class="bg"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <button class="search" @click="searchPerson">查询</button>
                            </el-col>
                            <el-col :span="6">
                                <div class="total">总共：{{ serviceData.length }}</div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="content_body">
                        <ul>
                            <li :class="[v.status == '1' ? 'item1' : '', 'item']" v-for="(v, i) in serviceData" :key="i"
                                @click="getTopRight(v.id)">
                                <img src="../../../assets/img/homecare/avater.png"></img>
                                <span>{{ v.personName }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content_right" v-if="isRightShow">
                    <div class="close">
                        <img src="../../../assets/img/homecare/close.png" @click='closeS' />
                    </div>
                    <div class="user_info">
                        <div class="top">
                            <img :src="formData.personPhoto" class="avatar" />
                            <div class="right">
                                <p>姓名：{{ formData.personName }}</p>
                                <p>性别：{{ formData.personSex === '1' ? '男' : '女' }}</p>
                                <p>年龄：{{ formData.personAge }}</p>
                                <p>联系电话：{{ formData.personPhone }}</p>
                            </div>
                        </div>
                        <div class="center">
                            <p class="city">{{ formData.address }}</p>
                        </div>
                        <div class="work_laod">
                            <div class="workload_header">
                                <div class="workload_header_title">
                                    <img src="../../../assets/img/homecare/work.png" />
                                    <span>工作统计</span>
                                </div>
                                <div>
                                    <el-date-picker v-model="time" type="date" value-format='yyyy-MM-dd'
                                        style="width:200px;" class='time' placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="table">
                            <div class='content_detail' style="overflow-y: auto; height: 25vh; line-height: 30px;">
                                <div style="text-align: center;">
                                    <div class='table_header'>
                                        <span>工单号</span>
                                        <span>服务内容</span>
                                        <span>服务类型</span>
                                    </div>
                                    <div class="table_body" v-for="(v, i) in tableData" :key="i" @click='goOdetail(v)'>
                                        <span>{{ v.orderNum }}</span>
                                        <span>{{ v.serveproductName }}</span>
                                        <span>{{ v.serviceTypeName }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bth_group">
                            <div class="group">
                                <img src="../../../assets/img/homecare/video.png" @click="goVideo" />
                            </div>
                            <div class="group">
                                <img src="../../../assets/img/homecare/see.png" @click="goSee" />
                            </div>
                        </div>
                        <div class="date_picker_container" v-if='seeGj'>
                            <el-date-picker v-model="startDateTime1" class='time' type="datetime"
                                value-format='yyyy-MM-dd HH:mm:ss' placeholder="选择开始时间" style="width:135px;">
                            </el-date-picker>
                            <span>至</span>
                            <el-date-picker v-model="endDateTime1" type="datetime" value-format='yyyy-MM-dd HH:mm:ss'
                                class='time' placeholder="选择结束时间" style="width:135px;">
                            </el-date-picker>
                            <button class="search" @click="searchGj">查询</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="serviceBg">
                <div class="cont">
                    <div v-for="(v, i) in oldType" :key="i" :class="[oldIndex === i ? 'active' : '']"
                        @click='oldClick(i)'>{{
                            v.name }}</div>
                </div>
            </div>
        </div>
        <!-- 弹窗 end -->
        <shipingtonghua v-if="videoModal" :userId="userinfo.id" :mobilePhone='userinfo.personPhone'
            :closeSP.sync="videoModal"></shipingtonghua>
        <!-- 工单信息弹框 -->
        <el-dialog :visible.sync="disVisible" title='工单信息' width="30%" custom-class="speinfo" style='margin-top:28vh;'
            :before-close="handleClose">
            <div class="top">
                <div class="left">
                    <div class="info">
                        <p><span class='text'>工单号：</span>{{ infoData.orderNum }}</p>
                        <p><span class='text'>客户姓名：</span>{{ infoData.customerName }}</p>
                        <p><span class='text'>服务开始时间：</span>{{ infoData.timeStart }}</p>
                        <p><span class='text'>服务结束时间：</span>{{ infoData.timeEnd }}</p>
                        <p><span class='text'>服务种类：</span>{{ infoData.serviceTypeName }}</p>
                        <p><span class='text'>服务状态：</span>
                            <span v-if="infoData.states===0">待派发</span>
                            <span v-if="infoData.states===1">待处理</span>
                            <span v-if="infoData.states===2">待回访</span>
                            <span v-if="infoData.states===3">已完成</span>
                            <span v-if="infoData.states===4">待作废</span>
                            <span v-if="infoData.states===5">已作废</span>
                        </p>
                        <p class="add"><span class="first text">地址：</span><span>{{ infoData.address }}</span></p>
                    </div>
                </div>
                <!-- <div class="right" @click="showVideo">视频通话</div> -->
            </div>
        </el-dialog>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import * as echarts from "echarts"
import shipingtonghua from "@/components/shipingtonghua.vue"
import city_line from './line.js'
export default {
    name: "visualized",
    components: {
        shipingtonghua,
    },
    data() {
        return {
            oldType: [
                {
                    name: '残联居家', value: 0
                },
                {
                    name: '服务工单',
                }
            ],
            oldIndex: 1,
            serviceData: [],
            form: {

            },
            map: null,
            formData: {},
            tableData: [],
            time: '',
            isRightShow: false,
            videoModal: false,
            startDateTime1: '',
            endDateTime1: '',
            seeGj: false,
            object3Dlayer: {},
            line3D: {},
            marker: null, //地图标记点
            markers: [],
            polyline: null,
            disVisible: false,
            infoData: {},
            regionId:'',
            cid:'',
        }
    },
    created() {
        this.orgName = this.$store.state.info.orgName
        this.regionId = this.$store.state.info.orgId
        this.cid = this.regionId
        this.getService()
        this.getService1()  //服务人员打点
    },
    beforeDestroy() {
        // 组件销毁前清除定时器  
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
    _methods: {
        searchPerson() {
            this.serviceData = []
            this.getService()
            this.getService1()
        },
        getService() {
            this.$http
                .request({
                    url: "/jjyl/admin/clBigScreen/info/findServiceStaffList",
                    method: "POST",
                    data: {
                        dataId:this.cid,
                        ...this.form,
                        orgType:695
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.serviceData = res.content
                        }
                    }
                })
        },
        //跳转页面
        oldClick(i) {
            this.$emit('refreshClick', i)
        },
        getDetail(id) {
            this.$http
                .request({
                    url: "/jjyl/admin/serviceStaffCustomerCenter/info/getById",
                    method: "POST",
                    data: {
                        id: id,
                        orgType: 499
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        if (res.content && res.content !== null) {
                            this.formData = res.content
                            let data = [this.formData]
                            this.renderMapMarker(data)
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        closeS() {
            this.isRightShow = false
        },

        getTopRight(id) {
            this.isRightShow = true
            try {
                this.map.remove(this.markers)
            } catch (err) {
            }
            this.getDetail(id)
            this.getLine('', 2)
            this.$http
                .request({
                    url: "/jjyl/servicePgd/info/findServicepgd",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 100,
                        type: '3',
                        states: '3',
                        startDateTime1: this.startDateTime1,
                        endDateTime1: this.endDateTime1,
                        staffCustomerCenterId: id
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.tableData = res.content.list
                        }
                    }
                })
        },
        goVideo() {
            this.userinfo = this.formData
            this.videoModal = true
        },
        //点击查看轨迹
        goSee() {
            this.seeGj = true
        },
        searchGj() {
            this.$http
                .request({
                    url: "/jjyl/admin/clBigScreen/info/findServiceStaffTrace",
                    method: "POST",
                    data: {
                        id: this.formData.id,
                        startDateTime1: this.startDateTime1,
                        endDateTime1: this.endDateTime1
                    },

                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            let getTrajectoryList = []
                            getTrajectoryList = res.content ? res.content : []
                            if (getTrajectoryList.length > 0) {
                                let arr = []
                                getTrajectoryList.forEach((item) => {
                                    if (item) {
                                        item.longitude = item.startlng
                                        item.latitude = item.startlat
                                    }
                                })
                                arr = this.generateCoordinatePairs(getTrajectoryList)
                                this.map.setCenter([getTrajectoryList[0].startlng, getTrajectoryList[0].startlat])
                                this.renderMapMarker(getTrajectoryList)
                                this.getLine(arr, 1)
                            } else {
                                this.$message.warning("暂无足迹")
                            }

                        }
                    }
                })
        },
        generateCoordinatePairs(city_line) {
            var coordinatePairs = [];
            // 遍历city_line数组，生成坐标对
            for (var i = 0; i < city_line.length - 1; i++) {
                var pair = [
                    city_line[i].startlng + ',' + city_line[i].startlat,  // 当前点的 "经度,纬度"
                    city_line[i + 1].startlng + ',' + city_line[i + 1].startlat // 下一个点的 "经度,纬度"
                ];
                coordinatePairs.push(pair);
            }

            return coordinatePairs;
        },
        clear3DLayer(layer) {
            layer.clear();
        },
        // 显示轨迹
        getLine(data, value) {
            // this.potintMap()
            var object3Dlayer = new window.AMap.Object3DLayer({ zIndex: 10 });
            if (object3Dlayer) {
                object3Dlayer.clear(); // 清空上一次的轨迹
            }
            this.map.add(object3Dlayer);
            if (value == 2) {
                return
            }
            var Line3D = new window.AMap.Object3D.Line({ lineWidth: 12 });
            Line3D.transparent = true;
            Line3D.lineWidth = 8;
            var geometry = Line3D.geometry;
            const depth = 25;
            for (var i = 0; i < data.length; i++) {
                // 线段
                var od = data[i];

                var origin = od[0].split(',');
                origin = this.map.lngLatToGeodeticCoord([origin[0], origin[1]]);
                geometry.vertices.push(origin.x, origin.y, depth);
                geometry.vertexColors.push(0, 128, 0, 1);
                // geometry.vertexColors.push(255, 255, 255, 1)
                // 添加起始点标记

                var des = od[1].split(',');
                des = this.map.lngLatToGeodeticCoord([des[0], des[1]]);
                geometry.vertices.push(des.x, des.y, depth);
                geometry.vertexColors.push(0, 128, 0, 1)
            }

            object3Dlayer.add(Line3D);
        },
        //获取服务人员打点
        getService1() {
            this.$http
                .request({
                    url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 10000,
                        orgType:695
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            const serviceData = res.content.elderList.list || []
                            let data = serviceData.filter(
                                (item) => item.longitude && item.latitude
                            )
                            this.renderMapMarker(data)
                        }
                    }
                })
        },
        // 打点
        potintMap(longitude, latitude) {
            console.log(longitude, latitude)
            const self = this
            try {
                self.map.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
            self.marker = new AMap.Marker({
                //   icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [longitude, latitude],
            })
            console.log(self.marker, 'self.marker')
            self.map.add(self.marker)
            self.map.setFitView()
        },
        showVideo() {
            this.userinfo = this.infoData
            this.videoModal = true
        },
        renderMapMarker(data) {
            console.log(data, 'datarrr')
            try {
                this.map.remove(this.markers)
            } catch (err) {
                console.log(err)
            }
            this.markers = []
            var image = null
            image = require("@/assets/img/homecare/pull.png")
            let self = this
            data.forEach((item) => {
                var endIcon = new AMap.Icon({
                    size: new AMap.Size(32, 32),
                    image: require(item.isWork === '1' ? '@/assets/img/map/map-person2.png' : '@/assets/img/map/map-person1.png'),
                    imageSize: new AMap.Size(32, 32),
                })
                let marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: endIcon,
                    offset: new AMap.Pixel(-10, -16)
                })
                self.markers.push(marker)
                marker.on('click', async e => {
                    let html = ''
                    let data1 = null
                    console.log(item.pdgId,'pdgId')
                    if(item.pdgId){
                        item.id=item.pdgId
                        this.goOdetail(item)
                    }else{
                        const content = `<div class='map-modal' style='width: 260px;font-size:14px;'>
                                 <p class='m-t10'>联系人：${item.personName}</p>
                                <p class='m-t10'>联系电话：${item.personPhone}</p>
                                <p class='m-t10' style='display:flex'>
                                    <span style='white-space:nowrap'>联系地址：</span>
                                    <span>${item.address}</span>
                                </p>
                                <div>
                                </div>
                              </div>`

                    const infowindow = new AMap.InfoWindow({
                        content: content,
                        offset: new AMap.Pixel(0, -30)
                    })
                    infowindow.open(this.map, [
                        Number(item.longitude),
                        Number(item.latitude),
                    ])
                    }
                })
            })
            self.map.add(self.markers)
            // self.map.add(self.polygon)
            self.map.setFitView(self.markers) //视口自适应
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container1", {
                    _mapStyle: "amap://styles/darkblue",
                    get mapStyle() {
                        return this._mapStyle
                    },
                    set mapStyle(value) {
                        this._mapStyle = value
                    },
                    viewMode: '3D',
                    defaultCursor: 'pointer',
                    //  showBuildingBlock: false,
                    // expandZoomRange: true,
                    resizeEnable: true,
                    // zooms: [3, 20],
                    // pitch: 53,
                    // zoom: 8,
                    // center: [119.35039396070704,33.61379829846855]
                })
                // this.areaBG(this.map, this.regionName)
                this.map.setZoom(12)
                this.map.setCenter([119.015372, 33.61037])
                resolve()
            })
        },
        areaBG(map, cityName) {
            console.log(cityName, "cityName")
            AMap.service("AMap.DistrictSearch", function () {
                let opts = {
                    subdistrict: 0,
                    extensions: "all",
                    level: "district", // 查询行政级别为市
                }
                // 实例化DistrictSearch
                let district = new AMap.DistrictSearch(opts)
                district.setLevel("district")
                // 行政区查询
                district.search(`${cityName}`, function (status, result) {
                    // 获取边界信息
                    if (result && result != '{}') {
                        return
                    }
                    let bounds = result.districtList[0].boundaries
                    let polygons = []
                    if (bounds) {
                        for (let i = 0, l = bounds.length; i < l; i++) {
                            // 生成行政区划polygon
                            let polygon = new AMap.Polygon({
                                map: map,
                                strokeWeight: 1,
                                path: bounds[i],
                                fillOpacity: 0.3,
                                fillColor: "#2191E6",
                                strokeColor: "#007CDB",
                            })
                            polygons.push(polygon)
                            console.log(polygon)
                        }
                    }
                })
            })
        },
        //获取地址
        getDistrict(name = "中国") {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 3,
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0].districtList)
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        //工单弹框
        handleClose() {
            this.disVisible = false
        },
        goOdetail(v) {
            this.disVisible = true
            let data1=null
            this.$http
                .request({
                    url: "jjyl/servicePgd/info/findServicepgdById",
                    method: "POST",
                    data: {
                        id: v.id,
                        //  orgType:499
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        this.infoData = res.content
                    } else {
                        this.$message.error(res.message)
                    }
                })
        }
    },
    get methods() {
        return this._methods
    },
    set methods(value) {
        this._methods = value
    },
    async mounted() {
        this.$nextTick(() => {
        })
        let self = this
        await self.loadMap()
        //   self.getServiceProvider()
        window.addEventListener("resize", () => {
            // 自适应所有echarts
            const handleResize = () => {
                if (!checkFull()) {
                    self.onFullScreen = false
                }
            }
            window.onresize = handleResize
            function checkFull() {
                let isFull =
                    document.fullscreenElement ||
                    document.mozFullScreenElement ||
                    document.webkitFullscreenElement
                if (isFull === undefined) isFull = false
                return isFull
            }
            self.$nextTick(() => {
                self.echartOne && self.echartOne.resize() // 老人类别统计echarts
                self.echartTwo && self.echartTwo.resize() //改造人数统计echarts
                self.echartThree && self.echartThree.resize() //改造产品统计echarts
                self.echartFour && self.echartFour.resize() //自理类别统计echarts
            })
        })
        let arr = [[{ week: 1 }], [{ week: 2 }, { week: 3 }], []]
    },
    beforeDestory() {
        window.removeEventListener("resize")
    },
}
</script>

<style lang="less" scoped>
.serviceBg {
    background: url("../../../assets/img/homecare/bottbg.png") no-repeat;
    background-size: 100%;
    height: 40px;
    width: 262px;
    position: fixed;
    bottom: -10px;
    text-align: center;
    left: 38.5%;

    .cont {
        display: flex;
        color: #78A1D3;
        font-size: 13px;
        justify-content: center;
        margin-top: 9px;

        div:first-child {
            margin-right: 20px;
        }

        div:last-child {
            margin-left: 20px;
        }
    }

    .active {
        color: #fff;
        padding-bottom: 5px;
        border-bottom: 1px solid #57EAE7
    }
}

.bigdata_container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url("../../../assets/img/homecare/bg.png") no-repeat center center;
    background-size: 100% 100%;

    .bigdata_main {
        position: absolute;
        left: 0;
        top: 50px;
        right: 0;
        bottom: 0;

        .main_center {
            width: 100%;
            height: 100%;
        }

        .map {
            position: relative;
            margin-top: 30px;
            text-align: center;
            color: #4ac3ff;
            height: 100%;
            padding: 0 24px;
            //   background: url("../assets/img/tc.png") no-repeat center center;
            background-size: 100% 100%;

            &:nth-child(1) {
                position: relative;
                top: -10px;
                position: relative;
                padding: 30px 3px 5px;
                box-sizing: border-box;
                overflow: hidden;

                .map_wrapper {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    // background: url("../assets/img/tc.png") no-repeat center
                    //     center;
                    background-size: 100% 100%;
                }
            }

            &:nth-child(1) {
                margin-top: 4px;
            }
        }
    }
}

.content_left {
    box-sizing: border-box;
    position: absolute;
    z-index: 100;
    top: 20%;
    bottom: 60px;
    left: 20px;
    width: 535px;
    padding: 30px;
    background: url('../../../assets/img/homecare/left.png') no-repeat 50%;
    background-size: 100% 100%;
    opacity: .8;

    .bg {
        /deep/ .el-input__inner {
            background: rgba(55, 72, 92, .9);
            line-height: 28px;
            height: 28px;
            border: none;
        }
    }

    .total {
        width: 100%;
        height: 36px;
        line-height: 36px;
        color: #fff;
        text-align: center;
        background: url('../../../assets/img/homecare/total.png') no-repeat 50%;
        transform: translateY(-4px);
        background-size: 100% 100%;
        font-size: 12px;
    }
}

.content_body {
    position: absolute;
    top: 85px;
    bottom: 8%;
    right: 30px;
    left: 30px;
    overflow-y: auto;

    ul {
        display: flex;
        flex-wrap: wrap;

        .item {
            display: flex;
            -webkit-box-flex: 0;
            -ms-flex: 0 0 150px;
            flex: 0 0 150px;
            height: 60px;
            line-height: 60px;
            margin-bottom: 10px;
            text-align: center;
            background: url('../../../assets/img/homecare/ser.png') no-repeat 50%;
            background-size: 100% 100%;
            cursor: pointer;

            img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-left: 10.5%;
                margin-top: 8%;
            }

            span {
                -webkit-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                color: #37f0fe;
            }
        }

        .item1 {
            background: url('../../../assets/img/homecare/serBus.png') no-repeat;
            background-size: 100% 100%;

            span {
                color: #ED3131;
            }
        }

        .item:not(:nth-child(3n+1)) {
            margin-left: 7px;
        }
    }
}

.search {
    background: #57a3f3;
    padding: 5px 6px;
    margin-left: 10px;
    border: none;
    white-space: nowrap;
    font-size: 12px;
    color: #fff;
}

.content_right {
    overflow-y: auto;
    position: absolute;
    z-index: 100;
    top: 20%;
    bottom: 60px;
    right: 20px;
    padding: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 423px;
    background: rgba(8, 9, 33, .8);
    border: 2px solid rgba(92, 137, 173, .8);
    -webkit-box-shadow: 0 6px 11px 1px rgba(75, 75, 75, .06);
    box-shadow: 0 6px 11px 1px rgba(75, 75, 75, .06);
    opacity: .8;
    border-radius: 4px;

    .close {
        position: absolute;
        right: 10px;
        top: 10px;

        img {
            display: block;
            width: 14px;
            height: 14px;
            cursor: pointer;
        }
    }

    .user_info {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding-bottom: 15px;
        margin-bottom: 15px;
        color: #fff;
        font-size: 12px;
        border-bottom: 1px solid hsla(0, 0%, 100%, .2);

        .top {
            display: flex;

            .avatar {
                width: 84px;
                height: 95px;
                margin-right: 36px
            }

            .right {
                p {
                    color: #fff;
                    margin-bottom: 10px;
                    font-size: 12px;
                }
            }
        }

        .center {
            border-bottom: 1px solid rgba(57, 130, 246, .4);
            padding-bottom: 10px;
            width: 100%;

            .city {
                margin-top: 15px;
                padding-left: 24px;
                background: url('../../../assets/img/homecare/address.png') no-repeat 0;
                background-size: 16px 16px;
            }

        }
    }

    .work_laod {
        margin-top: 16px;
        width: 100%;

        .workload_header {
            display: flex;
            justify-content: space-between;

            .workload_header_title {
                font-size: 12px;
            }

            img {
                width: 14%;
                height: 14px;
                margin-right: 6px;
                margin-top: 2px;
            }

        }
    }

    .time {
        /deep/.el-input__inner {
            background: transparent;
            border-color: rgba(57, 130, 246, .4);
            height: 28px;
            line-height: 28px;
        }
    }

    .table {
        display: flex;
        width: 100%;
        margin-top: 10px;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        color: #fff;
        font-size: 12px;

        .content_detail {

            .table_header,
            .table_body {
                display: flex;

                span {
                    -webkit-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                }
            }

            .table_body {
                span {
                    font-size: 11px;
                }
            }

            .table_body:first-child {
                color: red;
            }
        }
    }

    .bth_group {
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        margin-top: 20px;
        width: 100%;

        img {
            display: block;
            width: 126px;
            height: 34px;
            cursor: pointer;
        }
    }

    .date_picker_container {
        display: flex;
        margin-top: 20px;

        span {
            display: inline-block;
            margin: 10px 8px 0;
        }

    }
}
.info{
    p{
        width:100%;
        margin-bottom:6px;
        .text{
            width:92px;
            display:inline-block;
            text-align:right;
        }
    }
}
</style>
